(() => {
  "use strict";

  function fetchData(endpoint, method = "GET", data = null) {
    const headers = {
      "Content-Type": "application/json",
      "X-API-KEY": "ab719406-49e9-4925-aeb3-f326f0bca5ff"
    };

    return (
      fetch(
        `https://b2bapi-partner.compasia.com/${endpoint}`,
        {
          method: method,
          headers: headers,
          body: method === "POST" ? JSON.stringify(data) : null,
        }
      )
        .then(response => response.json())
    );
  }

  function populateDropdown(dropdownId, items = [], valueField, textField, placeholderText) {
    const dropdown = document.getElementById(dropdownId);

    dropdown.innerHTML = `<option value="" disabled selected hidden>${placeholderText}</option>`;

    items.forEach(item => {
      // Ensure properties exist
      const option = document.createElement("option");
      option.value = item[valueField];  // Use dynamic value field
      option.textContent = item[textField]; // Use dynamic text field
      dropdown.appendChild(option);
    });
  }

  function removeAllChildren(element) {
    while (element.hasChildNodes()) {
      element.removeChild(element.lastChild);
    }
  }

  function deviceIssuesInputChanged(inputs, event) {
    if (event.target.value === "deis_none_above") {
      inputs.forEach(input => {
        if (input.value !== "deis_none_above") {
          input.checked = false;
        }
      });
    } else {
      inputs.forEach(input => {
        if (input.value === "deis_none_above") {
          input.checked = false;
        }
      });
    }
  }

  function safeAddEventListener(id, event, callback) {
    const el = document.getElementById(id);
    if (el) el.addEventListener(event, callback);
  }

  function main() {
    // Event listener for start trade in button click
    document.querySelectorAll(".js-trade-in-modal-trigger").forEach(modalTrigger => {
      modalTrigger.addEventListener("click", () => {
        const categoryDropdown = document.getElementById("productCategoryDropdown");

        if (categoryDropdown.children.length === 0) {
          categoryDropdown.closest(".cv-trade-in-form--input-wrapper").classList.add("cv-trade-in-form--loading");

          fetchData("api/v1/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/product-category")
            .then(result => {
              let i = 0;
        
              ["Smartphone", "Tablet", "Watch", "Laptop"].forEach(expecting => {
                if (result.data[i].productCategoryName === expecting) {
                  i += 1;
                  return;
                }

                for (let j = i + 1; j < result.data.length; ++j) {
                  if (result.data[j].productCategoryName === expecting) {
                    let temp = result.data[j];
                    result.data[j] = result.data[i];
                    result.data[i] = temp;
                    i += 1;
                    return;
                  }
                }
              });

              populateDropdown("productCategoryDropdown", result.data, "productCategoryId", "productCategoryName", "Select a category");
              categoryDropdown.closest(".cv-trade-in-form--input-wrapper").classList.remove("cv-trade-in-form--loading");
            });
        }
      });
    });

    // Event listener for category dropdown change
    safeAddEventListener("productCategoryDropdown", "change", (event) => {
    // document.getElementById("productCategoryDropdown").addEventListener("change", (event) => {
      const categoryId = event.target.value;

      removeAllChildren(document.getElementById("productGroupDropdown"));
      removeAllChildren(document.getElementById("productModelDropdown"));
      removeAllChildren(document.getElementById("productVariantDropdown"));

      if (categoryId) {
        document.getElementById("productCategoryDropdown").closest(".cv-trade-in-form--input-wrapper").classList.add("cv-trade-in-form--loading");

        fetchData(`api/v1/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/product-group?productCategoryId=${encodeURIComponent(categoryId)}`)
          .then(result => {
            populateDropdown("productGroupDropdown", result.data, "productGroupId", "productGroupName", "Select a brand");
            document.getElementById("groupDropdownContainer").removeAttribute("hidden");
            document.getElementById("productCategoryDropdown").closest(".cv-trade-in-form--input-wrapper").classList.remove("cv-trade-in-form--loading");
          });
      }
    });

    // Event listener for group dropdown change
    safeAddEventListener("productGroupDropdown", "change", (event) => {
    // document.getElementById("productGroupDropdown").addEventListener("change", (event) => {
      const groupId = event.target.value;

      removeAllChildren(document.getElementById("productModelDropdown"));
      removeAllChildren(document.getElementById("productVariantDropdown"));

      if (groupId) {
        document.getElementById("productGroupDropdown").closest(".cv-trade-in-form--input-wrapper").classList.add("cv-trade-in-form--loading");

        fetchData(`api/v1/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/product-model?productGroupId=${encodeURIComponent(groupId)}`)
          .then(result => {
            populateDropdown("productModelDropdown", result.data, "productId", "productName", "Select a model");
            document.getElementById("modelDropdownContainer").removeAttribute("hidden");
            document.getElementById("productGroupDropdown").closest(".cv-trade-in-form--input-wrapper").classList.remove("cv-trade-in-form--loading");
          });
      }
    });

    // Event listener for model dropdown change
    safeAddEventListener("productModelDropdown", "change", (event) => {
    // document.getElementById("productModelDropdown").addEventListener("change", (event) => {
      const productId = event.target.value;

      removeAllChildren(document.getElementById("productVariantDropdown"));

      if (productId) {
        document.getElementById("productModelDropdown").closest(".cv-trade-in-form--input-wrapper").classList.add("cv-trade-in-form--loading");

        fetchData(`api/v1/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/product-variant?productId=${encodeURIComponent(productId)}`)
          .then(result => {
            populateDropdown("productVariantDropdown", result.data, "productVariantId", "productVariantName", "Select a variant");
            document.getElementById("variantDropdownContainer").removeAttribute("hidden");
            document.getElementById("productModelDropdown").closest(".cv-trade-in-form--input-wrapper").classList.remove("cv-trade-in-form--loading");
          });
      }
    });

    // Event listener for variant dropdown change
    safeAddEventListener("productVariantDropdown", "change", (event) => {
    // document.getElementById("productVariantDropdown").addEventListener("change", (event) => {
      const productVariantId = event.target.value;

      if (productVariantId) {
        document.getElementById("tradeInContainerStep1Next").removeAttribute("hidden");
      } else {
        document.getElementById("tradeInContainerStep1Next").setAttribute("hidden", "");
      }
    });

    // Step 1 next button on click
    safeAddEventListener("tradeInContainerStep1Next", "click", () => {
    // document.getElementById("tradeInContainerStep1Next").addEventListener("click", () => {
      const questionsContainer = document.getElementById("diagnosticQuestionsContainer");
      const containerStep1 = document.getElementById("tradeInContainerStep1");
      containerStep1.querySelectorAll(".error-message").forEach(x => x.remove());

      const categoryDropdown = document.getElementById("productCategoryDropdown");
      const groupDropdown = document.getElementById("productGroupDropdown");
      const modelDropdown = document.getElementById("productModelDropdown");
      const variantDropdown = document.getElementById("productVariantDropdown");

      if (!categoryDropdown.value) {
        categoryDropdown.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
      }
      if (!groupDropdown.value) {
        groupDropdown.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
      }
      if (!modelDropdown.value) {
        modelDropdown.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
      }
      if (!variantDropdown.value) {
        variantDropdown.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
      } else {
        const productVariantId = variantDropdown.value;

        if (questionsContainer.dataset.productVariantId === productVariantId) {
          document.getElementById("tradeInContainerStep1").setAttribute("hidden", "");
          document.getElementById("tradeInContainerStep2").removeAttribute("hidden");
          document.getElementById("tradeInContainer").closest(".modal").scrollTo({ top: 0 });
          return;
        }

        questionsContainer.dataset.productVariantId = productVariantId;
        removeAllChildren(questionsContainer);

        document.getElementById("tradeInContainerStep1Next").classList.add("cv-trade-in-form--loading");

        fetchData(`api/v1/smart-exchange/integration-c2b-b2b-microsite/diagnostic/diagnostic-list?productVariantId=${encodeURIComponent(productVariantId)}`)
          .then(result => {
            if (!result.hasOwnProperty("data")) {
              let message = "";

              if (Array.isArray(result.message)) {
                message = result.message.join("; ");
              } else if (result.message instanceof String || typeof result.message === "string") {
                message = result.message;
              } else {
                message = result.message.EN;
              }

              document.getElementById("tradeInContainerStep1ErrorMessages").innerHTML = `<div class="error-message"><p>${message}</p></div>`;
              document.getElementById("tradeInContainerStep1Next").classList.remove("cv-trade-in-form--loading");
              return;
            }

            const questions = result.data;

            questions.diagnosticChecklists.forEach((checklist, i) => {
              const li = document.createElement("li");
              questionsContainer.append(li);

              const p = document.createElement("p");
              p.classList.add("cv-trade-in-form--group-label-paragraph");
              p.textContent = `${checklist.diagnosticFunctionalityName}`;
              if (checklist.diagnosticOptionGroup.diagnosticOptionGroupType === "multiple") {
                p.textCotent += " (Can select multiple choices)";
              }
              li.append(p);

              const div = document.createElement("div");
              div.classList.add("cv-trade-in-form--radio-group")
              div.dataset.questionCode = checklist.diagnosticChecklistCode;
              div.dataset.questionMode = checklist.diagnosticOptionGroup.diagnosticOptionGroupType;
              li.append(div);

              // Iterate over diagnostic options within each option group
              if (checklist.diagnosticOptionGroup.diagnosticOptionGroupType === "single") {
                checklist.diagnosticOptionGroup.diagnosticOptions.forEach((option, j) => {
                  div.insertAdjacentHTML("beforeend", `<input type="radio" id="checkbox-${i}-${j}-${option.diagnosticOptionCode}" name="${checklist.diagnosticChecklistCode}" value="${option.diagnosticOptionCode}"><label for="checkbox-${i}-${j}-${option.diagnosticOptionCode}">${option.diagnosticOptionName}</label>`);
                });
              } else if (checklist.diagnosticOptionGroup.diagnosticOptionGroupType === "multiple") {
                checklist.diagnosticOptionGroup.diagnosticOptions.forEach((option, j) => {
                  div.insertAdjacentHTML("beforeend", `<input type="checkbox" id="checkbox-${i}-${j}-${option.diagnosticOptionCode}" name="${checklist.diagnosticChecklistCode}" value="${option.diagnosticOptionCode}"><label for="checkbox-${i}-${j}-${option.diagnosticOptionCode}">${option.diagnosticOptionName}</label>`);
                });

                if (checklist.diagnosticOptionGroup.diagnosticOptionGroupCode === "device_issues") {
                  const inputs = div.querySelectorAll("input");
                  inputs.forEach(input => {
                    input.addEventListener("change", deviceIssuesInputChanged.bind(null, inputs));
                  });
                }
              } else {
                console.error("Unrecognize diagnosticOptionGroupType:", checklist.diagnosticOptionGroup.diagnosticOptionGroupType);
              }
            });

            document.getElementById("tradeInContainerStep1Next").classList.remove("cv-trade-in-form--loading");
            document.getElementById("tradeInContainerStep1").setAttribute("hidden", "");
            document.getElementById("tradeInContainerStep2").removeAttribute("hidden");
            document.getElementById("tradeInContainer").closest(".modal").scrollTo({ top: 0 });
          });
      }
    });

    // Step 2 next button on click
    safeAddEventListener("submitDiagnosticButton", "click", (event) => {
    // document.getElementById("submitDiagnosticButton").addEventListener("click", (event) => {
      const questionsContainer = document.getElementById("diagnosticQuestionsContainer");
      questionsContainer.querySelectorAll(".error-message").forEach(x => x.remove());

      const productVariantId = parseInt(document.getElementById("productVariantDropdown").value);
      const data = {
        productVariantId,
        diagnosticResult: {},
      };
      let hasError = false;

      questionsContainer.querySelectorAll("[data-question-code]").forEach(questionElement => {
        const questionCode = questionElement.dataset.questionCode;

        if (questionElement.dataset.questionMode === "single") {
          let value = null;

          questionElement.querySelectorAll(`input[type="radio"]`).forEach(input => {
            if (input.checked) {
              value = input.value;
            }
          });

          if (value === null) {
            questionElement.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
            hasError = true;
          } else {
            data.diagnosticResult[questionCode] = value;
          }
        } else {
          let value = [];

          questionElement.querySelectorAll(`input[type="checkbox"]`).forEach(input => {
            if (input.checked) {
              value.push(input.value);
            }
          });

          if (value.length === 0) {
            questionElement.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
            hasError = true;
          } else {
            data.diagnosticResult[questionCode] = value;
          }
        }
      });

      if (hasError) {
        return;
      }

      document.getElementById("submitDiagnosticButton").classList.add("cv-trade-in-form--loading");

      fetchData(`api/v1/smart-exchange/integration-c2b-b2b-microsite/diagnostic/device-diagnostic-result`, "POST", data)
        .then(result => {
          if (result.hasOwnProperty("data")) {
            const quotedPriceText = document.getElementById("quotedPriceText");
            quotedPriceText.textContent = result.data.quotedPrice;
            questionsContainer.dataset.deviceDiagnosticUuid = result.data.deviceDiagnosticUuid;

            document.getElementById("tradeInContainerStep2").setAttribute("hidden", "");
            document.getElementById("tradeInContainerStep3").removeAttribute("hidden");
            document.getElementById("tradeInContainer").closest(".modal").scrollTo({ top: 0 });
            document.getElementById("submitDiagnosticButton").classList.remove("cv-trade-in-form--loading");
            return;
          }

          let message = "";

          if (Array.isArray(result.message)) {
            message = result.message.join("; ");
          } else if (result.message instanceof String || typeof result.message === "string") {
            message = result.message;
          } else {
            message = result.message.EN;
          }

          document.getElementById("tradeInContainerStep2ErrorMessages").innerHTML = `<div class="error-message"><p>${message}</p></div>`;
          document.getElementById("submitDiagnosticButton").classList.remove("cv-trade-in-form--loading");
        });
    });

    // Step 3 next button (validating IMEI) on click
    safeAddEventListener("validateImeiButton", "click", () => {
    // document.getElementById("validateImeiButton").addEventListener("click", () => {
      const containerStep3 = document.getElementById("tradeInContainerStep3");
      containerStep3.querySelectorAll(".error-message").forEach(x => x.remove());

      const imeiInput = document.getElementById("imeiInput");
      const imeiNo = imeiInput.value;
      const productVariantId = document.getElementById("productVariantDropdown").value;

      if (!imeiNo) {
        imeiInput.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
        return;
      }

      document.getElementById("validateImeiButton").classList.add("cv-trade-in-form--loading");

      fetchData(`api/v1/smart-exchange/integration-c2b-b2b-microsite/product/trade-in/imei/${encodeURIComponent(imeiNo)}/validate/productVariantId/${encodeURIComponent(productVariantId)}`)
        .then(result => {
          if (result.hasOwnProperty("data")) {
            if (result.data.isValid) {
              document.getElementById("tradeInContainerStep3").setAttribute("hidden", "");
              document.getElementById("tradeInContainerStep4").removeAttribute("hidden");
              document.getElementById("tradeInContainer").closest(".modal").scrollTo({ top: 0 });
              document.getElementById("validateImeiButton").classList.remove("cv-trade-in-form--loading");

              const bankName = document.getElementById("personalDetailsBankName");

              if (bankName.children.length === 0) {
                // Load bank list
                fetchData("api/v1/smart-exchange/integration-c2b-b2b-microsite/bank/bank-list")
                  .then(result => {
                    populateDropdown("personalDetailsBankName", result.data, "bankId", "bankName", "Select a bank");
                  });
              }

              return;
            }
          }

          let message = "";

          if (Array.isArray(result.message)) {
            message = result.message.join("; ");
          } else if (result.message instanceof String || typeof result.message === "string") {
            message = result.message;
          } else {
            message = result.message.EN;
          }

          imeiInput.insertAdjacentHTML("afterend", `<div class="error-message"><p>${message}</p></div>`);
          document.getElementById("validateImeiButton").classList.remove("cv-trade-in-form--loading");
        });
    });

    // Step 4 next button (submit button) on click
    safeAddEventListener("personalDetailsSubmitButton", "click", () => {
    // document.getElementById("personalDetailsSubmitButton").addEventListener("click", () => {
      const containerStep4 = document.getElementById("tradeInContainerStep4");
      containerStep4.querySelectorAll(".error-message").forEach(x => x.remove());

      const fullNameInput = document.getElementById("personalDetailsFullName");
      const phoneInput = document.getElementById("personalDetailsPhone");
      const emailInput = document.getElementById("personalDetailsEmail");
      const bankNameDropdown = document.getElementById("personalDetailsBankName");
      const bankAccountNameInput = document.getElementById("personalDetailsBankAccountName");
      const bankAccountNumberInput = document.getElementById("personalDetailsBankAccountNumber");
      const postcodeInput = document.getElementById("personalDetailsPickUpPostcode");

      let hasError = false;
      
      if (!fullNameInput.value) {
        fullNameInput.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
        hasError = true;
      }
      if (!phoneInput.value) {
        phoneInput.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
        hasError = true;
      }
      if (!emailInput.value) {
        emailInput.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
        hasError = true;
      }
      if (!bankNameDropdown.value) {
        bankNameDropdown.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
        hasError = true;
      }
      if (!bankAccountNameInput.value) {
        bankAccountNameInput.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
        hasError = true;
      }
      if (!bankAccountNumberInput.value) {
        bankAccountNumberInput.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
        hasError = true;
      }
      if (!postcodeInput.value) {
        postcodeInput.insertAdjacentHTML("afterend", `<div class="error-message"><p>Required</p></div>`);
        hasError = true;
      }

      if (hasError) {
        return;
      }

      document.getElementById("personalDetailsSubmitButton").classList.add("cv-trade-in-form--loading");

      fetchData(`api/v1/smart-exchange/integration-c2b-b2b-microsite/region/postcode/${encodeURIComponent(postcodeInput.value)}/validate`)
        .then(result => {
          let isValid = false;

          if (result.hasOwnProperty("data")) {
            isValid = result.data.isValid;
          }

          if (!isValid) {
            let message = "Postcode is not available";
            document.getElementById("tradeInContainerStep4ErrorMessages").innerHTML = `<div class="error-message"><p>${message}</p></div>`;
            document.getElementById("personalDetailsSubmitButton").classList.remove("cv-trade-in-form--loading");
            return;
          }

          const deviceDiagnosticUuid = document.getElementById("diagnosticQuestionsContainer").dataset.deviceDiagnosticUuid;
          const imeiNo = document.getElementById("imeiInput").value;
          const productVariantId = document.getElementById("productVariantDropdown").value;

          const data = {
            deviceDiagnosticUuid: deviceDiagnosticUuid,
            imeiSerialNo: imeiNo,
            customerName: fullNameInput.value,
            customerEmail: emailInput.value,
            customerEmailConfirm: emailInput.value,
            customerMobilePhone: phoneInput.value,
            bankId: parseInt(bankNameDropdown.value),
            bankAccountNo: bankAccountNumberInput.value,
            bankAccountName: bankAccountNameInput.value,
            pickupDropoffType: "pickup",
            postcode: postcodeInput.value,
          };

          fetchData(`api/v1/smart-exchange/integration-c2b-b2b-microsite/order`, "POST", data)
            .then(result => {
              if (result.hasOwnProperty("data")) {
                console.log("Trade-in order number:", result.orderNo);
                document.querySelectorAll('.trade-in__pdp-success').forEach(x=>{x.classList.remove("hidden")});
                document.querySelectorAll('.js-trade-in-value-amount').forEach(x=>{x.textContent=`RM`+document.getElementById("quotedPriceText").textContent});
                document.getElementById("tradeInContainerStep4").setAttribute("hidden", "");
                document.getElementById("tradeInContainerStep5").removeAttribute("hidden");
                document.getElementById("tradeInContainer").closest(".modal").scrollTo({ top: 0 });
                document.getElementById("personalDetailsSubmitButton").classList.remove("cv-trade-in-form--loading");
                localStorage.setItem("trade-in-form-submitted",document.getElementById("quotedPriceText").textContent);
                document.head.insertAdjacentHTML("beforeend",`<style>.trade-in__card-products-on-cart .js-trade-in-modal-trigger{display:none !important;}</style>`);
                return;
              }

              let message = "";

              if (Array.isArray(result.message)) {
                message = result.message.join("; ");
              } else if (result.message instanceof String || typeof result.message === "string") {
                message = result.message;
              } else {
                message = result.message.EN;
              }

              document.getElementById("tradeInContainerStep4ErrorMessages").innerHTML = `<div class="error-message"><p>${message}</p></div>`;
              document.getElementById("personalDetailsSubmitButton").classList.remove("cv-trade-in-form--loading");
            });
        });
    });

    // Back buttons
    document.querySelectorAll(".cv-trade-in-form--step-back-button").forEach(backButton => {
      backButton.addEventListener("click", () => {
        Array.from(document.getElementById("tradeInContainer").children).forEach(container => {
          container.setAttribute("hidden", "");
        });

        document.getElementById(backButton.dataset.target).removeAttribute("hidden");
        document.getElementById("tradeInContainer").closest(".modal").scrollTo({ top: 0 });
      });
    });

    // Hide card in trade in section if the form has been submitted
    if(localStorage.getItem('trade-in-form-submitted') === null){
      document.getElementById("defaultHideTradeIn")?.remove();
    } else{
      // Show the trade-in message and amount
      document.querySelectorAll('.trade-in__pdp-success').forEach(x=>{x.classList.remove("hidden")});
      document.querySelectorAll('.js-trade-in-value-amount').forEach(x=>{x.textContent=`RM`+localStorage.getItem("trade-in-form-submitted")});
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main, { once: true });
  } else {
    main();
  }

})();
